export var SLATargetType;
(function (SLATargetType) {
    SLATargetType[SLATargetType["ALL"] = 0] = "ALL";
    SLATargetType[SLATargetType["FIRST_RESPONSE"] = 1] = "FIRST_RESPONSE";
    SLATargetType[SLATargetType["NEXT_RESPONSE"] = 2] = "NEXT_RESPONSE";
    SLATargetType[SLATargetType["RESOLVE"] = 3] = "RESOLVE";
})(SLATargetType || (SLATargetType = {}));
export var SLABreachType;
(function (SLABreachType) {
    SLABreachType[SLABreachType["BREACHED"] = 0] = "BREACHED";
    SLABreachType[SLABreachType["ABOUT_TO_BE_BREACHED"] = 1] = "ABOUT_TO_BE_BREACHED";
})(SLABreachType || (SLABreachType = {}));
export var SLABreachActionType;
(function (SLABreachActionType) {
    SLABreachActionType[SLABreachActionType["SEND_EMAIL"] = 0] = "SEND_EMAIL";
    SLABreachActionType[SLABreachActionType["IN_APP_NOTIFICATION"] = 1] = "IN_APP_NOTIFICATION";
    SLABreachActionType[SLABreachActionType["ASSIGN_TICKET"] = 2] = "ASSIGN_TICKET";
    SLABreachActionType[SLABreachActionType["SEND_WEBHOOK"] = 3] = "SEND_WEBHOOK";
    SLABreachActionType[SLABreachActionType["SEND_SMS"] = 4] = "SEND_SMS";
})(SLABreachActionType || (SLABreachActionType = {}));
;
export var SLATrigger;
(function (SLATrigger) {
    SLATrigger[SLATrigger["TICKET_CREATED"] = 0] = "TICKET_CREATED";
    SLATrigger[SLATrigger["TICKET_ASSIGNED"] = 1] = "TICKET_ASSIGNED";
})(SLATrigger || (SLATrigger = {}));
export var SLATimezoneType;
(function (SLATimezoneType) {
    SLATimezoneType[SLATimezoneType["TENANT"] = 10] = "TENANT";
    SLATimezoneType[SLATimezoneType["COMPANY"] = 20] = "COMPANY";
})(SLATimezoneType || (SLATimezoneType = {}));
;
//# sourceMappingURL=new-sla-policy-settings.i.js.map